import { useEffect } from "react";
import ReactGA from "react-ga4";

const GA_TRACKING_ID = "G-KMT6NKJ1EB"; // Replace with your GA ID

function usePageTracking(pathname) {
  // Initialize GA once
  useEffect(() => {
    ReactGA.initialize(GA_TRACKING_ID);
  }, []);

  // Send pageview on pathname change
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: pathname });
  }, [pathname]);
}

export default usePageTracking;

